module.exports = __webpack_public_path__ + "static/wildgeese-splash-58495b7bed3955f442307596b3baa14b.jpg";